import { Link } from 'react-router-dom';
import styles from './Button.module.css';
import { Spinner } from './Spinner.jsx';

/**
 * The one button in the product.
 *
 * variant: 'primary' (accent gradient) | 'secondary' | 'ghost' | 'pro' | 'danger'
 * size:    'sm' | 'md' (default) | 'lg'
 * block:   full width
 * loading: shows a spinner and disables the button
 *
 * Pass `to="/path"` to render an internal router link, or `href="https://…"`
 * for an external one. Both still look and behave like a button.
 */
export function Button({
  variant = 'primary',
  size = 'md',
  block = false,
  loading = false,
  disabled = false,
  to,
  href,
  className = '',
  children,
  ...rest
}) {
  const classes = [
    styles.btn,
    styles[variant],
    size !== 'md' && styles[size],
    block && styles.block,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const content = (
    <>
      {loading && <Spinner size={16} inline />}
      {children}
    </>
  );

  if (to && !disabled && !loading) {
    return (
      <Link to={to} className={classes} {...rest}>
        {content}
      </Link>
    );
  }

  if (href && !disabled && !loading) {
    return (
      <a href={href} className={classes} {...rest}>
        {content}
      </a>
    );
  }

  return (
    <button className={classes} disabled={disabled || loading} {...rest}>
      {content}
    </button>
  );
}
